// extracted by mini-css-extract-plugin
export var boldText = "_7a-4";
export var checkboxContainer = "_7a-6";
export var closeIcon = "_7a-i";
export var container = "_7a-0";
export var drawer = "_7a-8";
export var drawerContent = "_7a-9";
export var extraSmallText = "_7a-5";
export var fulfillmentGroupTable = "_7a-e";
export var largeText = "_7a-3";
export var loadingSpinnerContainer = "_7a-j";
export var mediumText = "_7a-2";
export var narrow = "_7a-f";
export var notificationLink = "_7a-l";
export var packageCheckIconContainer = "_7a-7";
export var slideoutHeaderActions = "_7a-g";
export var slideoutHeaderActionsShifted = "_7a-h";
export var slideoutHeaderContainer = "_7a-a";
export var slideoutModal = "_7a-c";
export var stickyHeaderWrapper = "_7a-b";
export var table = "_7a-k";
export var tableContainer = "_7a-d";
export var tertiaryText = "_7a-1";